var render = function render(){var _vm=this,_c=_vm._self._c;return _c('front-admin-hub',{attrs:{"module-key":"quote"}})
}
var staticRenderFns = []

export { render, staticRenderFns }